export default __webpack_public_path__ + "static/media/chani sad.2ad0e012.svg";